module.exports = __webpack_public_path__ + "static/media/b3_p14_clickable.d2d915fa.mp3";